import apiSlice from "./apiSlice";
const changePackagesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllChange: builder.query({
      query: (req) => ({
        url: `change`,
        params: req,
      }),
      keepUnusedDataFor: 1,
    }),
    getChangePackages: builder.query({
      query: ({ projectId, type }) => {
        const params = new URLSearchParams();
        if (projectId) params.append("projectId", projectId);
        if (type) params.append("type", type);
        return `WBS?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetChangePackagesQuery,
  useLazyGetChangePackagesQuery,
  useGetAllChangeQuery,
} = changePackagesSlice;
